import React, { useEffect } from 'react';

import ProjectWizard from './projectwizard';
import { useNavigate } from 'react-router-dom';

export const ProjectWizardDialog = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // props.getEntity(props.match.params.id);
  }, []);

  const handleClose = () => {
    navigate('/project/');
  };

  return <ProjectWizard finishEvent={() => {}} />;
};

const mapStateToProps = ({ project }) => ({
  projectEntity: project.entity,
  updateSuccess: project.updateSuccess,
});
